import React, { Component } from "react";
import { connect } from "react-redux";
import Loadable from "react-loadable";
import LoadableLoading from "~/components/mobile/molecules/LoadingPage";
import { withTitle } from "~/components/common/molecules/TitleHelmet";
import * as FAQAction from "~/store/faq/faqAction";

const FaqDetailPageMobile = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "mobile" */ "~/components/mobile/pages/FaqDetailApp"
    ),
  loading: LoadableLoading
});
const FaqDetailPageDesktop = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "desktop" */ "~/components/mobile/pages/FaqDetailApp"
    ),
  loading: LoadableLoading
});

class FaqDetail extends Component {
  // componentDidMount() {
  //   this.props.getAllFAQ();
  // }

  render() {
    const { device } = this.props;
    return (
      <React.Fragment>
        {device === "mobile" ? (
          <FaqDetailPageMobile {...this.props} />
        ) : (
          <FaqDetailPageDesktop {...this.props} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    global: {
      device: { type }
    },
    faq
  } = state;
  return {
    device: type,
    faq
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateShowedFAQByGroup: groupName =>
      dispatch(FAQAction.updateShowedFAQByGroup(groupName)),
    updateShowedFAQBySearch: searchValue =>
      dispatch(FAQAction.updateShowedFAQBySearch(searchValue)),
    getAllFAQ: () => dispatch(FAQAction.getAllFAQ())
  };
};

const FaqHelmet = withTitle({
  component: FaqDetail,
  title: "Medpro | Câu hỏi thường gặp"
});

export default connect(mapStateToProps, mapDispatchToProps)(FaqHelmet);
